import { render, staticRenderFns } from "./ProfileField.vue?vue&type=template&id=2f8fcc00"
import script from "./ProfileField.vue?vue&type=script&lang=ts"
export * from "./ProfileField.vue?vue&type=script&lang=ts"
import style0 from "@/components/acquisitionList/ui/itemDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports